export const CANVAS_CONTENT_WIDTH = 740
export const CANVAS_NARROW_CONTENT_WIDTH = 640
export const CANVAS_HORIZONTAL_PADDING = 40
export const CANVAS_NARROW_HORIZONTAL_PADDING = 30
export const CANVAS_NARROW_BREAKPOINT = CANVAS_NARROW_CONTENT_WIDTH + (CANVAS_NARROW_HORIZONTAL_PADDING * 2)
export const PLACEHOLDER_TILE_BORDER_WIDTH = 1

export const RIGHT_PANEL_MIN_WIDTH = 500
export const CHAT_MIN_WIDTH = 400
export const CHAT_DEFAULT_WIDTH = 620
export const CHAT_MAX_WIDTH = 1100
export const LEFT_PANE_WIDTH_VAR = '--leftPaneWidth'
export const SHOW_ON_MAP_ZOOM = 13
